import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularStakingReward: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_staking-reward"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="staking-reward icon"
      {...restProps}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 25 24"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M5.16094 18.5739L18.4327 5.2883H15.3395C14.984 5.2883 14.6958 5.00012 14.6958 4.64462C14.6958 4.28913 14.984 4.00095 15.3395 4.00095H20.5879V9.2974C20.5879 9.65289 20.2997 9.94108 19.9442 9.94108C19.5887 9.94108 19.3006 9.65289 19.3006 9.2974V6.24238L6.07102 19.4858C5.81968 19.7374 5.41229 19.7374 5.16094 19.4858C4.90944 19.234 4.90944 18.8257 5.16094 18.5739Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.412 7.41592C11.412 9.30275 9.88411 10.8318 7.99995 10.8318C6.11579 10.8318 4.58789 9.30275 4.58789 7.41592C4.58789 5.52909 6.11579 4 7.99995 4C9.88411 4 11.412 5.52909 11.412 7.41592ZM7.99995 9.54448C9.17181 9.54448 10.1247 8.59309 10.1247 7.41592C10.1247 6.23875 9.17181 5.28736 7.99995 5.28736C6.82809 5.28736 5.87522 6.23875 5.87522 7.41592C5.87522 8.59309 6.82809 9.54448 7.99995 9.54448Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.5879 16.6024C20.5879 18.4791 19.0682 20 17.1941 20C15.3201 20 13.8004 18.4791 13.8004 16.6024C13.8004 14.7257 15.3201 13.2049 17.1941 13.2049C19.0682 13.2049 20.5879 14.7257 20.5879 16.6024ZM17.1941 18.7126C18.3559 18.7126 19.3005 17.7695 19.3005 16.6024C19.3005 15.4354 18.3559 14.4922 17.1941 14.4922C16.0324 14.4922 15.0877 15.4354 15.0877 16.6024C15.0877 17.7695 16.0324 18.7126 17.1941 18.7126Z"
        />
      </svg>
    </span>
  );
};

export { RegularStakingReward };
